/* Match the mobile capsule to the section beneath it, without reading image pixels. */
(() => {
 const header = document.getElementById('tt-header');
 if (!header) return;
 if (window.ttHeaderContrastCleanup) window.ttHeaderContrastCleanup();
 const logo = header.querySelector('.tt-header__logo-img');
 const bar = header.querySelector('.tt-header__inner');
 let frame = 0;
 function update() {
  frame = 0;
  const r = bar.getBoundingClientRect();
  const x = Math.min(innerWidth - 1, r.left + 65), y = Math.max(0, Math.min(innerHeight - 1, r.top + r.height / 2));
  const beneath = document.elementsFromPoint(x, y).find(el => !header.contains(el) && !el.closest('.shopify-section-group-header-group'));
  let dark = false;
  if (innerWidth < 990 && beneath) {
   if (beneath.closest('.tt-jacob--hero, .tt-jacob__media')) dark = true;
   else {
    for (let el = beneath; el && el !== document.documentElement; el = el.parentElement) {
     const c = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
     if (!c || (c.length > 3 && Number(c[3]) < .5)) continue;
     const rgb = c.slice(0, 3).map(v => {v = Number(v) / 255;return v <= .04045 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4;});
     dark = .2126 * rgb[0] + .7152 * rgb[1] + .0722 * rgb[2] < .30;
     break;
    }
   }
  }
  header.classList.toggle('tt-header--on-dark', dark);
  const src = dark ? logo.dataset.creamSrc : logo.dataset.inkSrc;
  if (src && logo.getAttribute('src') !== src) logo.setAttribute('src', src);
 }
 function schedule(){if (!frame) frame=requestAnimationFrame(update);}
 window.addEventListener('scroll',schedule,{passive:true});
 window.addEventListener('resize',schedule);
 window.addEventListener('load',schedule);
 document.addEventListener('shopify:section:load',schedule);
 window.ttHeaderContrastCleanup=()=>{cancelAnimationFrame(frame);window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);window.removeEventListener('load',schedule);document.removeEventListener('shopify:section:load',schedule);};
 update();
})();
